import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="forgot-password-page">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-3">
          <div className="inline-flex items-center justify-center mx-auto">
            <img src="/logo-mark.png" alt="Arrivo" className="w-14 h-14 object-contain" />
          </div>
          <h1 className="text-3xl tracking-tight font-light" style={{ fontFamily: "'Manrope', sans-serif" }}>
            ARRIVO
          </h1>
          <p className="text-sm text-muted-foreground">
            {sent ? "Check your inbox" : "Reset your password"}
          </p>
        </div>

        {sent ? (
          <div className="space-y-4 text-center" data-testid="forgot-password-sent">
            <p className="text-sm text-muted-foreground">
              If <span className="text-foreground">{email}</span> is a registered account, we've sent a reset link. The link expires in 60 minutes.
            </p>
            <Link to="/login" className="text-sm text-primary hover:underline" data-testid="back-to-login-link">
              ← Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
            {error && (
              <div className="p-3 rounded-md bg-destructive/10 border border-destructive/20 text-sm text-red-400">
                {error}
              </div>
            )}
            <div className="space-y-2">
              <Label htmlFor="email" className="text-sm text-muted-foreground">Email</Label>
              <Input
                id="email" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} required autoFocus
                placeholder="you@example.com"
                className="bg-card border-border" data-testid="forgot-email-input"
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
              {loading ? "Sending..." : "Send reset link"}
            </Button>
            <div className="text-center">
              <Link to="/login" className="text-xs text-muted-foreground hover:text-foreground" data-testid="back-to-login-link">
                ← Back to sign in
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
